import { Component, Input, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from '../../layout/loader/loader.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalHeaderComponent } from '../../modals/modal-header/modal-header.component';

@Component({
  selector: 'app-order-product-edit-form',
  templateUrl: './order-product-edit-form.component.html',
  styleUrls: ['./order-product-edit-form.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    LoaderComponent,
    ModalHeaderComponent
  ],
  standalone: true
})
export class OrderProductEditComponent implements OnInit {
  @Input() orderItem: any = {};
  @Input() orderId: string = "";

  modalTitle: string = 'Bestelling product wijzigen';
  modalStyle: boolean = true;

  errorMessage: string = '';
  loading: boolean = false;
  productList: any[] = [];

  search: string = "";

  constructor(private apiService: ApiService, private activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  updateProduct() {
    this.loading = true;
    // this.orderItem.invoice_number = "test";
    // this.orderItem.payment_status = "PAID";
    // this.orderItem.status = "COMPLETED";
    this.apiService.put(`/office/orders/${this.orderId}/items/${this.orderItem.id}`, this.orderItem)
      .then(() => {
        this.loading = false;
        this.activeModal.close(true);
      })
      .catch((e) => {
        console.log(e)

        this.loading = false;
        if (e.status === 422 && e.error?.error) {
          const errors = e.error.error;
          const messages = [];

          for (const field in errors) {
            if (errors[field].length) {
              messages.push(...errors[field]);
            }
          }

          this.errorMessage = messages.join(' ');
        } else {
          this.errorMessage = 'Er ging iets niet goed.';
        }
      });
  }
}
